




























































































































































































































































































































import LineChart from "@/components/chart/LineChart.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import xlsx from "xlsx";
import {
  meters,
  childMeters,
  queryMeter,
  QueryMeterReq,
  updateMeter,
  setParentMeter,
  SetMeterParentReq,
  SearchMeterReq,
  GetMetersReq,
  meterTypes,
  MeterTypeReq,
  BatchBindMeterCostReq,
  BatchBindUserReq,
  batchBindMeterCost,
  batchBindUser,
  addMeter,
} from "@/api/meter";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  Meter,
  User,
  MeterCost,
  Company,
  Address,
  MeterType,
  SubMeterType,
} from "@/api/baseDefine";
import { queryMeterCost, meterCosts, GetMeterCostReq } from "@/api/meterCost";
import { formatDate } from "@/utils/dateUtil";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { queryUser, QueryUserReq, UserReq, users } from "../../api/user";
import { getAddresses, GetAddress } from "../../api/address";
import { GetMeterReq, getMeterData, History } from "../../api/home";
import { QueryMeterCostReq } from "../../api/meterCost";
import { Getter } from "vuex";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { ElForm } from "element-ui/types/form";
import * as googleMap from "vue2-google-maps";
import axios, { AxiosResponse } from "axios";
import { globalData } from "@/utils/config";
import { ParseAddress } from "@/utils/parseAddress";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    LineChart,
  },
})
export default class AddMeter extends Vue {
  private chartPage: number = 0;
  private dialogLocation = false;
  private timeArray: string[] = [];
  private time = "";
  private meterTypes: MeterType[] = [];
  private subMeterTypes: SubMeterType[] = [];
  private subMeterVisible: boolean = false;
  private connectMeterIDVisible: boolean = false;
  private ptstart = {
    lat: 35.44699,
    lng: 139.6335582,
  };

  private bRouteMaxReadingVisible = true;
  private dialogBatch = false;
  private dialogChart = false;
  private dialogEditMeter = false;
  private dialogBatchWrite = false;
  private isSearch = false;
  private editMeter: Meter = <Meter>{};

  private queryCompanys: Company[] = [];
  private queryUsers: User[] = [];
  private queryInstallUsers: User[] = [];
  private queryMeters: Meter[] = [];
  private queryMeterCosts: MeterCost[] = [];
  private addressSearchType = 1;
  private queryAddresses: Address[] = [];
  private searchMeter: Meter = <Meter>{};
  private loading: boolean = false;

  private listLoading: boolean = true;

  private dialogType = "edit"; //判断弹出层是添加还是编辑
  private total = 0;
  private parentMeter: string = "";
  private roleKey = "";

  private batchParentMeterID = "";
  private batchBindUserID = "";
  private batchBindMeterCostName = "";
  private selectItems = new Array<Meter>();
  private mqttTypes = ["normal", "tsl", "aws"];
  private lineChartData = {
    xDatas: ["0"],
    usages: [0],
    readings: [0],
  };

  private listQuery: GetMetersReq = <GetMetersReq>{
    page: 1,
    pageSize: 10,
  };

  private showBatch = false;
  public onSelectOwnUser(b) {
    if (b) {
      this.queryOwnUser("");
    }
  }
  public onSelectInstallUser(b) {
    if (b) {
      this.queryInstallUser("");
    }
  }

  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }

  public onSelectParentMeterID(b) {
    if (b) {
      this.queryMeter("");
    }
  }
  public onSelectChangeProvince(b) {
    if (b) {
      this.addressSearchType = 2;
      this.queryAddress("");
    }
  }

  public onSelectChangeCity(b) {
    if (b) {
      this.addressSearchType = 3;
      this.queryAddress("");
    }
  }
  public onSelectChangeDetail(b) {
    if (b) {
      this.addressSearchType = 4;
      this.queryAddress("");
    }
  }

  public onSelectMeterCost(b) {
    if (b) {
      this.queryMeterCost("");
    }
  }
  public async queryMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      let req: GetMetersReq = <GetMetersReq>{};
      req.meter = <Meter>{};
      req.meter.meterID = query;
      if (this.editMeter.meterTypeID > 0) {
        req.meter.meterTypeID = this.editMeter.meterTypeID;
      }
      const res = await meters(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }

  public onSelectConnectMeterID(b) {
    if (b) {
      this.queryConnectedMeter("");
    }
  }
  public async queryConnectedMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      let req: GetMetersReq = <GetMetersReq>{};
      req.meter = <Meter>{};
      req.meter.meterID = query;
      req.meter.meterTypeID = 2;
      // req.meter.subMeterTypeIndex = 1;
      const res = await meters(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }
  public async queryMeterCost(query: string) {
    console.log("queryMeterCost", this.editMeter);
    if (!this.editMeter.meterTypeID) {
      this.queryMeterCosts = new Array();
      return;
    }
    if (query !== null && query !== undefined) {
      this.loading = true;
      let req: GetMeterCostReq = <GetMeterCostReq>{};
      if (this.editMeter.meterTypeID > 0) {
        req.meterTypeID = this.editMeter.meterTypeID;
      }
      req.name = query;
      req.page = 1;
      req.pageSize = 100;
      const res = await meterCosts(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryMeterCosts = res.data.meterCostData.list;
        this.loading = false;
      }
    }
  }
  public async queryOwnUser(query) {
    let req: UserReq = <UserReq>{};
    req.appUserType = 0;
    req.userNO = query;
    req.page = 1;
    req.pageSize = 100;
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await users(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }
  public async queryInstallUser(query: string) {
    let req: UserReq = <UserReq>{};
    req.page = 1;
    req.pageSize = 100;
    req.appUserType = 1;
    req.userNO = query;
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await users(req);
      if (res.code === ResCode.SUCCESS) {
        this.queryInstallUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }
  public async queryAddress(query: string) {
    let req: GetAddress = <GetAddress>{};
    let address: Address = <Address>{};
    req.page = 1;
    req.pageSize = 10;
    req.address = address;
    req.searchType = this.addressSearchType;
    this.loading = true;
    address.country = query;
    address.province = query;
    address.city = query;
    address.detail = query;
    const res = await getAddresses(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryAddresses = res.data.addressesData.list;
      this.loading = false;
    }
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }

  public loadChild(tree, treeNode, resolve) {
    console.log(tree);
    console.log(treeNode);
    childMeters({ meterID: tree.id }).then((res) => {
      let childs: Meter[] = res.data.meters.list;
      resolve(childs);
    });
  }

  public reset() {
    this.editMeter = <Meter>{};
  }

  private async onMeterTypeChange() {
    console.log("onMeterTypeChange", this.editMeter.meterTypeID);

    let subMeterTypeArray = this.$t("subMeterTypeArray");
    let subMeterType: string[] =
      subMeterTypeArray[this.editMeter.meterTypeID - 1];
    this.subMeterTypes = [];
    if (subMeterType.length > 0) {
      for (let i = 0; i < subMeterType.length; i++) {
        this.subMeterTypes.push(<SubMeterType>{
          lable: subMeterType[i],
          index: i,
        });
      }
      this.subMeterVisible = true;
    } else {
      this.subMeterVisible = false;
    }
    if (
      (this.editMeter.meterTypeID == 1 || this.editMeter.meterTypeID == 3) &&
      this.editMeter.subMeterTypeIndex == 2
    ) {
      this.connectMeterIDVisible = true;
    } else {
      this.connectMeterIDVisible = false;
    }
    // if (this.editMeter.meterTypeID == 5) {
    //   this.bRouteMaxReadingVisible = true;
    // } else {
    //   this.bRouteMaxReadingVisible = false;
    //   if (this.editMeter.routeBMaxReading > 0) {
    //     this.editMeter.routeBMaxReading = 0;
    //   }
    // }
    if (!!this.editMeter.meterCostName) {
      this.editMeter.meterCostName = "";
    }
  }

  private map;
  private async created() {
    let meterArray = this.$t("meterTypeArray");
    let meterTypeResponse = await meterTypes(<MeterTypeReq>{});
    for (let i = 0; i < meterTypeResponse.data.meterTypes.list.length; i++) {
      let meterType: MeterType = <MeterType>{
        id: meterTypeResponse.data.meterTypes.list[i].id,
        name: meterArray[meterTypeResponse.data.meterTypes.list[i].id - 1],
      };
      this.meterTypes.push(meterType);
    }
    console.log("created", this.meterTypes);

    this.timeArray = [
      this.$t("timeArray.hours").toString(),
      this.$t("timeArray.days").toString(),
      this.$t("timeArray.weeks").toString(),
      this.$t("timeArray.months").toString(),
      this.$t("timeArray.years").toString(),
    ];
    this.time = this.timeArray[0];
    this.center = {
      lat: this.ptstart.lat,
      lng: this.ptstart.lng,
    };
  }

  private center;
  private clickMap(e, e2) {
    // console.log(e.latLng)
    let latLng = e.latLng;
    let lat = latLng.lat();
    let lng = latLng.lng();
    let ll = lat + "," + lng;
    let c = 1;
    let language = "zh-CN";
    let self = this;
    axios
      .get(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          ll +
          "&language=" +
          language +
          "&key=" +
          globalData.googleKey
      )
      .then(function (response) {
        let r = ParseAddress.dealReturnAddress(response.data.results);
        self.editMeter.latitude = lat;
        self.editMeter.longitude = lng;
        self.editMeter.country = r.country;
        self.editMeter.province = r.province;
        self.editMeter.city = r.city;
        self.editMeter.address = r.street;
        self.ptstart.lat = lat;
        self.ptstart.lng = lng;
      })
      .catch(function (error) {
        // 请求失败处理
        console.log(error);
      });
  }

  private showMap() {
    this.dialogLocation = true;
  }

  public dataRules = {
    meterID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    meterTypeID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    expireDate: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    meterCostName: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    cycle: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
    maxReading: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
    routeBMaxReading: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
    subMeterTypeIndex: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    connetcMeterID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    connectFactor: [
      { required: true, trigger: "blur", validator: this.validateNumber },
    ],
  };

  private validateNotNull(rule: any, value: any, callback: any) {
    if (value == 0) {
      callback();
      return;
    }
    if (!value || value.length <= 0) {
      console.log("-----------------------------", value);
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validateNumber(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else if (isNaN(Number(value))) {
      callback(new Error(this.$t("validate.onlyNumberPermission").toString()));
    } else {
      callback();
    }
  }

  public async handleEditMeter() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.newMeter();
      } else {
        return false;
      }
    });
  }

  public async newMeter() {
    console.log(this.editMeter);
    let b1 =
      !!this.editMeter.latitude &&
      !!this.editMeter.longitude &&
      !!this.editMeter.country &&
      !!this.editMeter.province &&
      !!this.editMeter.city &&
      !!this.editMeter.address &&
      !!this.editMeter.buildNo;
    let b2 =
      !this.editMeter.latitude &&
      !this.editMeter.longitude &&
      !this.editMeter.country &&
      !this.editMeter.province &&
      !this.editMeter.city &&
      !this.editMeter.address &&
      !this.editMeter.buildNo;
    if (!b1 && !b2) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.pleaseInputAllAddressInfo").toString(),
        type: "warning",
      });
      this.chartPage = 0;
      return;
    }
    if (!!this.editMeter.installDate) {
      this.editMeter.installDate = formatDate(
        new Date(this.editMeter.installDate)
      );
    }
    if (!!this.editMeter.expireDate) {
      this.editMeter.expireDate = formatDate(
        new Date(this.editMeter.expireDate)
      );
    }
    const res = await addMeter(this.editMeter);
    if (res.code === ResCode.SUCCESS) {
      this.$router.push("/meter/list");
    }
  }
}
